export type Difficulty = 1 | 2 | 3;
export type TestPaperGenerateType = 1 | 2 | 3; // 试卷组成策略(目前只有随机生效)1.抽题 2.根据配置抽提  3.随机
export type LookStatus = 'see' | 'view' | 'review';

export const arrayDifficulties = [
  { type: 1, text: '简单' },
  { type: 2, text: '普通' },
  { type: 3, text: '简单' },
];

export const arrayQuestions = [
  { type: 1, text: '单选题' },
  { type: 2, text: '多选题' },
  { type: 3, text: '判断题' },
  { type: 4, text: '填空题' },
  { type: 5, text: '问答题' },
];

export const difficultyTypes: Record<Difficulty, string> = {
  1: '简单',
  2: '普通',
  3: '难度'
};

export const testPaperGenerateTypes: Record<TestPaperGenerateType, string> = {
  1: '抽题',
  2: '配置抽题',
  3: '随机组题'
};

export const lookStatus = {
  see: 'see', // 管理员查看
  view: 'view', // 用户查看
  review: 'review', // 管理员批改
}

export const questionTypes = {
  1: {
    value: '单选题',
    color: '#1A8CFE',
    bgColor: 'rgba(26, 140, 254, 0.1)'
  },
  2: {
    value: '多选题',
    color: '#1DC88C',
    bgColor: 'rgba(29, 200, 140, 0.1)'
  },
  3: {
    value: '判断题',
    color: '#F76377',
    bgColor: 'rgba(247, 99, 119, 0.1)'
  },
  4: {
    value: '填空题',
    color: '#A06AD2',
    bgColor: 'rgba(160, 106, 210, 0.1)'
  },
  5: {
    value: '问答题',
    color: '#C9A310',
    bgColor: 'rgba(201, 163, 16, 0.1)'
  },
};

export const optionsNum = ["A", "B", "C", "D", "E", "F", "G", "H", "I"];

export const formatTime = (time: number): string => {
  // 秒转为分//秒
  let _hour: string | number = 0;
  let _minute: string | number = 0;
  let _second: string | number = 0;
  if (time < 3600) {
    _minute = Math.floor(time / 60);
    _second = Math.ceil(time % 60);
    _minute = _minute >= 10 ? _minute : ('0' + _minute);
    _second = _second >= 10 ? _second : ('0' + _second);
    return `00:${_minute}:${_second}`;
  } else {
    _hour = Math.floor(time / 3600);
    let _time = Math.floor(time % 3600);
    _minute = Math.floor(_time / 60);
    _second = Math.ceil(_time % 60);
    _minute = _minute >= 10 ? _minute : ('0' + _minute);
    _second = _second >= 10 ? _second : ('0' + _second);
    return `${_hour}:${_minute}:${_second}`;
  }
}

export default {
  questionTypes,
  difficultyTypes,
  optionsNum,
  arrayDifficulties,
  arrayQuestions
}
